import React from 'react';

import Button from './Button';
import Input from './Input';

import style from '../../styles/filters.module.scss';
import dataGripStore from '../../../../store/DataGrip';
import CustomSelect from '../../../../components/CustomSelect';
import filtersInHeaderStore from '../../../../store/FiltersInHeader';
import { observer } from 'mobx-react-lite';

let authors :any[] = [];

const Logo = observer(() => {
  if (!filtersInHeaderStore.author) {
    authors = dataGripStore.dataGrip.author.list;
  }
  const options = authors.map((title: string) => ({ id: title, title }));
  options.unshift({ id: '', title: 'All employees' });

  return (
    <div className={style.header_filters}>
        <CustomSelect
          value={filtersInHeaderStore.author}
          options={options}
          onChange={(author: any) => {
            filtersInHeaderStore.updateAuthor(author);
            dataGripStore.updateStatistic();
          }}
        />
      <Input
        type="from"
        placeholder="с"
      />
      {' — '}
      <Input
        type="to"
        placeholder="по"
      />
      <div className={style.header_filters_fast}>
        <Button
          title="sidebar.filters.all"
          type="all"
        />
        <Button
          title="sidebar.filters.year"
          type="year"
        />
        <Button
          title="sidebar.filters.halfYear"
          type="halfYear"
        />
        <Button
          title="sidebar.filters.month"
          type="month"
        />
        <Button
          title="sidebar.filters.week"
          type="week"
        />
      </div>
    </div>
  );
});

export default Logo;
